import React, {FC, useEffect, useState} from 'react'
import {LinearProgress} from '@mui/material'
import {Story, StoryStatus} from '@graphql/types'
import StoryEditor from '@components/Stories/StoryEditor/StoryEditor'
import {useStoryQuery} from '../gql/StoriesEditor.generated'
import {EditStoryProps} from './EditStoryProps'

const EditStory: FC<EditStoryProps> = ({uid}) => {
  const [story, setStory] = useState<Story>()

  const {loading} = useStoryQuery({
    variables: {uid},
    skip: !uid || uid.includes('new'),
    onCompleted: data => {
      setStory(data?.story as Story)
    }
  })

  useEffect(() => {
    if (!uid || uid.includes('new')) {
      setStory({
        canonicalUrl: '',
        createdAt: new Date(),
        description: '',
        id: '',
        isActive: false,
        publicationsCount: 0,
        status: StoryStatus.Archive,
        title: '',
        uid: '',
        updatedAt: new Date()
      } as Story)
    }
  }, [uid])

  return <>{loading || !story ? <LinearProgress color='primary' /> : <StoryEditor story={story} />}</>
}

export default EditStory
